/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
// tslint:disable:no-magic-numbers
import { Component, HostBinding, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { NavigationStart, Router } from '@angular/router';
import { APP_NAME } from '@gh/config';
import { WaitingContext } from '@gh/core-ui';
import { interval$ } from '@gh/rx';
import { distinctUntilChanged$, filter$, map$, throttleTime$ } from '@gh/rx/operators';
import { compact } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@gh/core-ui";
import * as i3 from "@angular/flex-layout/extended";
import * as i4 from "@angular/common";
import * as i5 from "@angular/flex-layout/flex";
import * as i6 from "@angular/material/button";
import * as i7 from "@angular/material/tooltip";
import * as i8 from "@angular/material/icon";
import * as i9 from "@angular/material/progress-bar";
import * as i10 from "../../../core-mls/translation/translate.pipe";
var _c0 = ["menuTooltip"];
var _c1 = ["closeTooltip"];
function ExtRootLayoutComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
} }
var _c2 = [[["", "ghExtRootLayoutNavigation", ""]], [["", "ghExtRootLayoutMobileBar", ""]], [["", "ghExtRootLayoutTopMenu", ""]], [["", "ghExtRootLayoutContent", ""]]];
var _c3 = ["[ghExtRootLayoutNavigation]", "[ghExtRootLayoutMobileBar]", "[ghExtRootLayoutTopMenu]", "[ghExtRootLayoutContent]"];
var MOBILE_TOP_MENU_HEIGHT = 112;
var MOBILE_TOP_MENU_SHOW_THRESHOLD = 150;
var ExtRootLayout = /** @class */ (function () {
    function ExtRootLayout() {
    }
    return ExtRootLayout;
}());
export { ExtRootLayout };
var ExtRootLayoutComponent = /** @class */ (function () {
    function ExtRootLayoutComponent(router, waitingContext) {
        this.router = router;
        this.waitingContext = waitingContext;
        this.isNavigationOpened = false;
        this.isMenuOnTop = true;
        this.isMenuFixed = false;
        this.backgroundWaiting = false;
        this.blockedWaiting = false;
        this.lastScrollTop = 0;
    }
    Object.defineProperty(ExtRootLayoutComponent.prototype, "isFirstRouteActivated", {
        get: function () {
            return this.router.navigated;
        },
        enumerable: true,
        configurable: true
    });
    ExtRootLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.htmlEl = document.documentElement; // tslint:disable-line:no-non-null-assertion
        this.htmlScrollSubscription = interval$(90).pipe(map$(function () { return _this.htmlEl.scrollTop; }), distinctUntilChanged$(), throttleTime$(100))
            .subscribe(function () { return _this.onPageScroll(); });
        this.router.events.pipe(filter$(function (event) { return event instanceof NavigationStart; }))
            .subscribe(function () {
            _this.setNavigationOpened(false);
        });
    };
    ExtRootLayoutComponent.prototype.ngDoCheck = function () {
        var _a = this.waitingContext, mode = _a.mode, waiting = _a.waiting;
        // display all waiting effects in background
        // this.blockedWaiting = mode !== WaitingMode.Background && waiting;
        this.backgroundWaiting = /*mode === WaitingMode.Background && */ waiting;
    };
    ExtRootLayoutComponent.prototype.ngOnDestroy = function () {
        this.htmlScrollSubscription.unsubscribe();
    };
    ExtRootLayoutComponent.prototype.toggleNavigation = function () {
        this.setNavigationOpened(!this.isNavigationOpened);
    };
    ExtRootLayoutComponent.prototype.closeNavigation = function () {
        this.setNavigationOpened(false);
    };
    ExtRootLayoutComponent.prototype.setTitle = function (title) {
        this.title = title;
        this.updateDocumentTitle();
    };
    ExtRootLayoutComponent.prototype.resetTitle = function () {
        this.title = void 0;
        this.updateDocumentTitle();
    };
    ExtRootLayoutComponent.prototype.onPageScroll = function () {
        var bodyScrollTop = this.htmlEl.scrollTop;
        if (bodyScrollTop - this.lastScrollTop > 0 || bodyScrollTop === 0) {
            this.isMenuFixed = false;
        }
        else if (this.lastScrollTop - bodyScrollTop > MOBILE_TOP_MENU_SHOW_THRESHOLD
            && bodyScrollTop > MOBILE_TOP_MENU_HEIGHT) {
            this.isMenuFixed = true;
        }
        this.isMenuOnTop = bodyScrollTop < MOBILE_TOP_MENU_HEIGHT;
        this.lastScrollTop = bodyScrollTop;
    };
    ExtRootLayoutComponent.prototype.setNavigationOpened = function (isNavigationOpened) {
        this.isNavigationOpened = isNavigationOpened;
        this.menuTooltip.hide();
        this.closeTooltip.hide();
        this.htmlEl.classList.toggle('cdk-global-scrollblock', isNavigationOpened);
    };
    ExtRootLayoutComponent.prototype.updateDocumentTitle = function () {
        document.title = compact(["" + APP_NAME, this.title]).join(' - ');
    };
    ExtRootLayoutComponent.ɵfac = function ExtRootLayoutComponent_Factory(t) { return new (t || ExtRootLayoutComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.WaitingContext)); };
    ExtRootLayoutComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ExtRootLayoutComponent, selectors: [["gh-ext-root-layout"]], viewQuery: function ExtRootLayoutComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, true);
            i0.ɵɵviewQuery(_c1, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTooltip = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeTooltip = _t.first);
        } }, hostVars: 4, hostBindings: function ExtRootLayoutComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("is-top-menu", ctx.isMenuOnTop)("is-fixed-menu", ctx.isMenuFixed);
        } }, exportAs: ["ghExtRootLayout"], features: [i0.ɵɵProvidersFeature([{ provide: ExtRootLayout, useExisting: ExtRootLayoutComponent }])], ngContentSelectors: _c3, decls: 29, vars: 11, consts: [["fxShow", "", "fxHide.lt-md", "", 1, "m-navigation-header-underlay", "ext-primary-bg"], [1, "m-root"], ["fxShow.lt-md", "", "class", "m-navigation-overlay", 4, "ngIf"], [1, "m-navigation"], ["fxLayout", "column", "fxLayoutAlign", "start", "fxFlex", "", 1, "m-navigation-root", "ext-primary-bg"], ["fxHide", "", "fxShow.lt-md", "", "fxLayout", "row", "fxLayoutAlign", "start center", 1, "m-navigation-header", "ext-mobile-content", "ext-primary-contrast-bg"], ["type", "button", "mat-icon-button", "", "color", "primary", 3, "matTooltip", "click"], ["closeTooltip", "matTooltip"], ["svgIcon", "gh:close"], ["fxFlex", "", "fxLayout", "row", "fxLayoutAlign", "center center"], ["src", "/ef05a4176a1a27c00c8e389eff1cc5c3.gif"], ["fxFlex", "", 1, "m-navigation-content"], ["fxHide", "", "fxShow.sm", "", "fxFlex", "", 1, "m-navigation-placeholder", 3, "click"], ["ngClass.lt-md", "ext-primary-bg", 1, "m-top-menu", "ext-elevated-panel"], ["fxShow.lt-md", "", "fxHide", "", "fxLayoutAlign", "space-between center", 1, "ext-mobile-content"], ["type", "button", "mat-icon-button", "", "color", "accent", 3, "matTooltip", "click"], ["menuTooltip", "matTooltip"], ["svgIcon", "gh:menu"], [1, "m-page-title", "ext-primary-contrast-color"], ["mode", "indeterminate", 1, "m-preloader", 3, "hidden"], [1, "m-content"], ["fxShow.lt-md", "", 1, "m-navigation-overlay"]], template: function ExtRootLayoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2);
            i0.ɵɵelement(0, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtemplate(2, ExtRootLayoutComponent_div_2_Template, 1, 0, "div", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵelementStart(6, "button", 6, 7);
            i0.ɵɵlistener("click", function ExtRootLayoutComponent_Template_button_click_6_listener() { return ctx.toggleNavigation(); });
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelement(9, "mat-icon", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 9);
            i0.ɵɵelement(11, "img", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 11);
            i0.ɵɵprojection(13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 12);
            i0.ɵɵlistener("click", function ExtRootLayoutComponent_Template_div_click_14_listener() { return ctx.closeNavigation(); });
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "div", 13);
            i0.ɵɵelementStart(16, "div", 14);
            i0.ɵɵelementStart(17, "button", 15, 16);
            i0.ɵɵlistener("click", function ExtRootLayoutComponent_Template_button_click_17_listener() { return ctx.toggleNavigation(); });
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelement(20, "mat-icon", 17);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "div", 18);
            i0.ɵɵtext(22);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "div");
            i0.ɵɵprojection(24, 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(25, 2);
            i0.ɵɵelement(26, "mat-progress-bar", 19);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "div", 20);
            i0.ɵɵprojection(28, 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isNavigationOpened);
            i0.ɵɵadvance(1);
            i0.ɵɵclassProp("is-navigation-opened", ctx.isNavigationOpened);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(8, 7, "lbl_close"));
            i0.ɵɵadvance(11);
            i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(19, 9, "lbl_menu"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("hidden", !ctx.backgroundWaiting || !ctx.isFirstRouteActivated);
        } }, directives: [i3.DefaultShowHideDirective, i4.NgIf, i5.DefaultLayoutDirective, i5.DefaultLayoutAlignDirective, i5.DefaultFlexDirective, i6.MatButton, i7.MatTooltip, i8.MatIcon, i3.DefaultClassDirective, i9.MatProgressBar], pipes: [i10.TranslatePipe], styles: ["[_nghost-%COMP%] {\n  position: relative;\n  display: block;\n  height: 100%; }\n\n.m-root[_ngcontent-%COMP%] {\n  height: 100%;\n  display: flex;\n  flex-direction: column; }\n\n.m-content[_ngcontent-%COMP%] {\n  flex: 1; }\n\n.m-top-menu[_ngcontent-%COMP%] {\n  position: relative; }\n\n.m-preloader[_ngcontent-%COMP%] {\n  height: 10px;\n  z-index: 1; }\n\n@media (max-width: 959px) {\n  .m-navigation-overlay[_ngcontent-%COMP%] {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 200;\n    background: rgba(0, 0, 0, 0.12); }\n  .m-navigation[_ngcontent-%COMP%] {\n    left: -100%;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 202;\n    transition: transform 0.2s ease-in; }\n  .m-navigation.is-navigation-opened[_ngcontent-%COMP%] {\n    transform: translateX(100%); }\n  .m-navigation-root[_ngcontent-%COMP%] {\n    width: 100%; }\n  .m-navigation-header[_ngcontent-%COMP%] {\n    width: 100%;\n    min-height: 48px; }\n  .m-navigation-content[_ngcontent-%COMP%] {\n    overflow: auto; }\n  [_nghost-%COMP%]:not(.is-top-menu):not(.is-fixed-menu)   .m-preloader[_ngcontent-%COMP%] {\n    position: fixed;\n    top: 0; }\n  .is-fixed-menu[_nghost-%COMP%]   .m-top-menu[_ngcontent-%COMP%] {\n    position: fixed;\n    left: 0;\n    right: 0;\n    z-index: 201; }\n  .is-fixed-menu[_nghost-%COMP%]   .m-content[_ngcontent-%COMP%] {\n    padding-top: 112px; }\n  .is-top-menu[_nghost-%COMP%]   .m-preloader[_ngcontent-%COMP%], .is-fixed-menu[_nghost-%COMP%]   .m-preloader[_ngcontent-%COMP%] {\n    position: absolute;\n    bottom: 0; } }\n\n@media (min-width: 600px) and (max-width: 959px) {\n  .m-navigation-root[_ngcontent-%COMP%] {\n    max-width: 400px !important; } }\n\n@media (min-width: 960px) {\n  .m-navigation-header-underlay[_ngcontent-%COMP%] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: -1; }\n  .m-navigation[_ngcontent-%COMP%], .m-top-menu[_ngcontent-%COMP%] {\n    margin-bottom: 15px; }\n  .m-content[_ngcontent-%COMP%] {\n    margin-bottom: 15px; }\n  .m-top-menu[_ngcontent-%COMP%] {\n    overflow: hidden; }\n  .m-preloader[_ngcontent-%COMP%] {\n    position: absolute;\n    bottom: 0; } }\n\n@media (min-width: 960px) and (max-width: 1279px) {\n  .m-root[_ngcontent-%COMP%] {\n    margin: 0 auto;\n    max-width: 900px; }\n  .m-navigation-header-underlay[_ngcontent-%COMP%] {\n    height: 60px; } }\n\n@media (min-width: 1280px) and (max-width: 1599px) {\n  .m-root[_ngcontent-%COMP%] {\n    margin: 0 auto;\n    max-width: 1200px; }\n  .m-navigation-header-underlay[_ngcontent-%COMP%] {\n    height: 70px; } }\n\n@media (min-width: 1600px) and (max-width: 5000px) {\n  .m-root[_ngcontent-%COMP%] {\n    margin: 0 auto;\n    max-width: 1600px; }\n  .m-navigation-header-underlay[_ngcontent-%COMP%] {\n    height: 70px; } }"] });
    return ExtRootLayoutComponent;
}());
export { ExtRootLayoutComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ExtRootLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'gh-ext-root-layout',
                templateUrl: 'ext-root-layout.component.html',
                styleUrls: ['ext-root-layout.component.scss'],
                exportAs: 'ghExtRootLayout',
                providers: [{ provide: ExtRootLayout, useExisting: ExtRootLayoutComponent }],
            }]
    }], function () { return [{ type: i1.Router }, { type: i2.WaitingContext }]; }, { isMenuOnTop: [{
            type: HostBinding,
            args: ['class.is-top-menu']
        }], isMenuFixed: [{
            type: HostBinding,
            args: ['class.is-fixed-menu']
        }], menuTooltip: [{
            type: ViewChild,
            args: ['menuTooltip', { static: false }]
        }], closeTooltip: [{
            type: ViewChild,
            args: ['closeTooltip', { static: false }]
        }] }); })();
